














































import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator';
import SegmentControls from '@/components/SegmentControls.vue';
import DetailList from '@/components/DetailList.vue';
import Icon from '@/components/Icon.vue';
import clone from '@/lib/clone';
import dayjs from 'dayjs';
import 'ant-design-vue/dist/antd.css';
import {Moment} from 'moment';
import {DatePicker} from 'ant-design-vue';
import QRCode from '@/components/QRCode.vue';

Vue.use(DatePicker);

@Component({
  components: {QRCode, DetailList, SegmentControls, Icon}
})
export default class Details extends Vue {
  monthIncome = 0;
  monthPay = 0;
  time = '';
  year = dayjs(new Date()).format('YYYY');
  month = dayjs(new Date()).format('MM');
  selectedMonthList!: Result[];
  toggle = false;

  beforeCreate() {
    this.$store.commit('fetchRecords');
  }

  created() {
    if (this.$store.state.firstTimeFlag) {
      this.qrToggle();
      this.$store.commit('handleNotFirst');
    }

    this.monthTotal(this.year, this.month);
  }

  @Watch('time')
  onTimeChanged() {
    this.year = dayjs(this.time).format('YYYY');
    this.month = dayjs(this.time).format('MM');
    this.monthTotal(this.year, this.month);
  }

  qrToggle() {
    if (document.documentElement.clientWidth > 500) {
      this.toggle = true;
    }
  }

  get recordList() {
    return (this.$store.state as RootState).recordList;
  }

  onChange(date: Moment | string, dateString: string) {
    this.time = new Date(dateString).toISOString();
  }

  monthTotal(x: string, y: string) {
    this.monthPay = 0;
    this.monthIncome = 0;
    const total = this.groupedList;
    this.selectedMonthList = total.filter(item => dayjs(item.title).format('MM') === y);
    for (let i = 0; i < this.selectedMonthList.length; i++) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.monthPay += this.selectedMonthList[i].payTotal!;
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.monthIncome += this.selectedMonthList[i].incomeTotal!;
    }
    return '';
  }

  get groupedList() {
    const {recordList} = this;
    if (recordList.length === 0) {return []; }
    const newList = clone(recordList).sort((a, b) => dayjs(b.createdAt).valueOf() - dayjs(a.createdAt).valueOf());
    const result: Result[] = [
      {
        title: dayjs(newList[0].createdAt).format('YYYY-MM-DD'),
        payTotal: 0,
        incomeTotal: 0,
        items: [newList[0]]
      }
    ];
    for (let i = 1; i < newList.length; i++) {
      const current = newList[i];
      const last = result[result.length - 1];
      if (dayjs(last.title).isSame(dayjs(current.createdAt), 'day')) {
        last.items.push(current);
      } else {
        result.push({title: dayjs(current.createdAt).format('YYYY-MM-DD'), items: [current]});
      }
    }
    result.map(group => {
      group.payTotal = group.items.reduce((sum, item) => {
        if (item.type === '-') {
          sum += item.amount;
        }
        return sum;
      }, 0);
      group.incomeTotal = group.items.reduce((sum, item) => {
        if (item.type === '+') {
          sum += item.amount;
        }
        return sum;
      }, 0);
    });
    return result;
  }
}
